import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BellIcon } from "lucide-react";
import { RootDispatch, RootState } from "../../store";
import { getTaskManagerUnreadNotificationCount } from "../../store/slices/taskmanagementSlice";
import { useRightSidebar } from "../../Context/TaskManagerNotification";

const TaskManagerNotificationBell: React.FC = () => {
  const dispatch: RootDispatch = useDispatch();
  const unreadCount = useSelector(
    (state: RootState) => state.TaskManagement.unreadCount,
  );
  const { open: openNotifications } = useRightSidebar();

  const handleBellClick = () => {
    openNotifications();
    dispatch(getTaskManagerUnreadNotificationCount(true));
  };

  return (
    <button
      onClick={handleBellClick}
      className="relative p-2 rounded hover:bg-gray-100 hover:text-black transition duration-300"
      title="Open notifications"
    >
      <BellIcon size={16} />
      {unreadCount && unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-semibold px-1.5 py-0.5 rounded-full min-w-[16px] h-4 flex items-center justify-center">
          {unreadCount}
        </span>
      )}
    </button>
  );
};

export default TaskManagerNotificationBell;
